export function sliders() {
  
  var testimonials_slider = $(".js-home-testimonials");
  var autoplay = testimonials_slider.data("autoplay");
  var autoplaySpeed = testimonials_slider.data("autoplay-speed");
  
  var collaboration_works_slider = $(".js-collaboration-projects-slider");

  testimonials_slider.owlCarousel({
    loop: true,
    nav: true,
    autoHeight: false,
    margin: 0,
    autoplayTimeout: autoplaySpeed,
    autoplay: autoplay,
    navContainer: ".js-testimonials-nav-container",
    dotsContainer: ".js-testimonials-dots-container",
    navText: ['<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.01318 8.88156L14.1224 8.87758L14.1231 7.12625L3.99534 7.13024L9.06279 2.06279L7.92895 0.928955L0.857886 8.00002L1.99172 9.13386L1.99387 9.13171L7.93102 15.0689L9.06575 13.9341L4.01318 8.88156Z" fill="#11111C"></path></svg>','<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.9868 7.11844L0.877582 7.12242L0.876893 8.87375L11.0047 8.86976L5.93721 13.9372L7.07105 15.071L14.1421 7.99998L13.0083 6.86614L13.0061 6.86829L7.06898 0.931141L5.93425 2.06587L10.9868 7.11844Z" fill="#11111C"></path></svg>'],
    items: 1
  });
  
  collaboration_works_slider.owlCarousel({
    loop: 0,
    margin: 0,
    items: 3,
    slideBy: 3,
    responsive : {
      0: {
        items: 1,
      },
      992: {
        items: 3,
      }
    }
  });

  var generic_slider = "generic-slider__slider-wrapper";
  var generic_slider_navContainerClassName = 'js-generic-slider-nav-container';
  var generic_slider_dotsContainerClassName = 'js-generic-slider-dots-container';
  
  $(".js-generic-slider").each(function(index, item) {
    var rootIdClassName = 'owl--' + generic_slider + '--' + index;
    $(item).closest('.' + generic_slider).addClass(rootIdClassName);
    $(item).owlCarousel({
      loop: true,
      nav: false,
      autoHeight: true,
      margin: 0,
      navContainer: '.' + rootIdClassName + ' .' + generic_slider_navContainerClassName,
      dotsContainer: '.' + rootIdClassName + ' .' + generic_slider_dotsContainerClassName,
      items: 1,
      responsive : {
        0: {
          nav: false,
          navText: '',
        },
        1200: {
          nav: true,
          navText: ['<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 256 256" style="enable-background:new 0 0 256 256;" xml:space="preserve"> <polygon points="207.093,30.187 176.907,0 48.907,128 176.907,256 207.093,225.813 109.28,128"/></svg>','<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 256 256" style="enable-background:new 0 0 256 256;" xml:space="preserve"><polygon points="79.093,0 48.907,30.187 146.72,128 48.907,225.813 79.093,256 207.093,128"/></svg>'],
        }
      }
    });
  });

}


// WEBPACK FOOTER //
// ./assets/js/modules/sliders.js